import * as React from 'react'
import { useTranslation } from 'react-i18next'

import './buttonStyles.sass'
import PaginationLoader from '../paginationLoader/PaginationLoader'

interface Props {
    label: string
    small?: boolean
    id?: string
    secondary?: boolean
    mobile?: boolean
    tertiary?: boolean
    onClick?: (e?: any) => void
    type?: 'submit' | 'button'
    disabled?: boolean
    filters?: boolean
    className?: string
    isLoading?: boolean
}

const Button: React.FunctionComponent<Props> = ({
    label,
    type,
    id,
    disabled,
    onClick,
    secondary,
    small,
    tertiary,
    mobile,
    className,
    filters,
    isLoading = false,
    ...otherProps
}: Props) => {
    let classname = 'button'
    if (small) classname = classname + ' button_small'
    if (mobile) classname = classname + ' button_mobile'
    if (tertiary) classname = classname + ' button_tertiary'
    if (secondary) classname = classname + ' button_secondary'
    if (filters) classname = classname + ' button_filters'
    if (disabled) classname = classname + ' button_disabled'

    const [t] = useTranslation()

    return (
        <button
            id={id}
            type={type}
            onClick={onClick}
            className={className || classname}
            disabled={disabled}
            {...otherProps}
        >
            {isLoading ? <PaginationLoader white={!secondary} /> : t(label)}
        </button>
    )
}

export default Button
